<template>
  <span>
    <span
        v-for="value in cluster"
        :key="value.id"
        class="mb-3"
    >
      <input
          type="checkbox"
          :name="value.slug"
          value="1"
          checked="checked"
      >
      <span>{{ value.name }}</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'MonitoringGroupSelection',

  props: {
    cluster: {
      type: [Array, Object, null],
      default: null
    }
  },

  computed: {
  }
}
</script>